<template>
  <div>
    <v-dialog hide-overlay v-model="modalDrawing" style="width: 0px; height: 0px" width="0px" height="0px">
      <v-card ref="refDrawingPanel" :width="letterSize * captchaLength"></v-card>
    </v-dialog>
    <v-dialog v-model="isLoading" style="width: 100%; height: 100%"> </v-dialog>
    <v-card class="box-container ma-0 pa-2" align="center" justify="center">
      <v-card-actions class="row-header ma-0 pa-2" v-if="text" style="pointer-events: none">
        <v-col class="ma-0 pa-0">
          <v-row v-for="(line, idx) in text.split('\n')" :key="idx" class="ma-0 pa-0" align="center" justify="center">
            <span class="subtitle" style="white-space: pre-wrap; text-align: justify">{{ line }}</span>
          </v-row>
        </v-col>
      </v-card-actions>
      <v-card-actions class="row-content ma-0 pa-2" style="pointer-events: none">
        <v-col class="ma-0 pa-0">
          <v-card class="ma-0 pa-2" align="center" justify="center" :width="letterSize * captchaLength + 16" :height="letterSize + 16">
            <v-img v-if="!isLoading && image" class="ma-0 pa-0" :src="image" :width="letterSize * captchaLength" height="letterSize"> </v-img>
            <v-container v-else color="white" class="ma-0 pa-0" align="center" justify="center" ref="refCaptchaContainer" :style="'overflow: hidden; pointer-events: none; width: ' + letterSize * captchaLength + 'px; height: ' + letterSize + 'px;'">
              <span v-for="(ch, idx) in captcha" :key="idx" class="text-center ma-0 pa-0" :style="'white-space: pre; justify-content: center; pointer-events: none; align-items: center; display: inline-flex; width: ' + letterSize + 'px; height: ' + letterSize + 'px; font-size: ' + letterSize * 0.7 + 'px;'" :class="'myStyle' + captchaClass.charAt(idx)">{{ ch }}</span>
            </v-container>
          </v-card>
        </v-col>
      </v-card-actions>
      <v-card-actions class="row-header ma-0 pa-2">
        <v-col class="ma-4 pa-0">
          <v-text-field ref="refClientInput" @input="changeInput" v-model="clientInput" class="ma-0 pa-0 centered-input" :style="'width: ' + letterSize * captchaLength + 'px; font-size: ' + letterSize * 0.8 + 'px;'" dense hide-details></v-text-field>
        </v-col>
      </v-card-actions>
      <v-card-actions class="row-header ma-0 pa-0">
        <v-row class="ma-2 pa-0" align="center" justify="center">
          <v-col cols="3" class="ma-0 pa-0" justify="start">
            <v-card v-if="buttonCancelText" align="center" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="'info'" class="ma-0 pa-2 no-text-transform white--text" @click="resolve(null)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonCancelText }}</span>
            </v-card>
          </v-col>
          <v-col cols="1" class="ma-0 pa-0"> </v-col>
          <v-col cols="3" class="ma-0 pa-0" justify="start">
            <v-card v-if="buttonOKText" :disabled="buttonOKDisabled" align="center" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="'info'" class="ma-0 pa-2 no-text-transform white--text" @click="resolve(true)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonOKText }}</span>
            </v-card>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import domtoimage from "dom-to-image";
import { TR } from "../../main";

export default {
  props: {},
  data() {
    return {
      modalDrawing: false,
      image: null,
      clientInput: "",
      captcha: "",
      captchaClass: "",
      letterSize: 40,
      captchaLength: 4,
      text: "",
      buttonOKText: TR.OK,
      buttonCancelText: TR.Cancel,
      buttonOKDisabled: false,
      isLoading: false,
      retries: 1,
    };
  },
  computed: {},
  methods: {
    resolve(result) {
      this.dialog.result = result;
      if (result) {
        if (this.clientInput == this.captcha) {
          this.dialog.close();
        } else {
          this.dialogLoader.showError(TR.Captcha_WrongInput);
          this.clientInput = "";
          this.buttonOKDisabled = true;
          this.retries++;
          this.generateCaptcha();
          setTimeout(() => {
            this.buttonOKDisabled = false;
          }, 3000);
        }
      } else {
        this.dialog.close();
      }
    },
    generateCaptcha() {
      this.isLoading = true;
      this.image = null;
      this.clientInput = "";
      this.captcha = "";
      this.captchaClass = "";

      for (var i = 0; i < this.captchaLength; i++) {
        this.captchaClass += Math.floor(Math.random() * 6);
        this.captcha += Math.floor(Math.random() * 10).toString();
      }
      this.modalDrawing = true;
      this.$nextTick(() => {
        var vm = this;
        var wi = this.letterSize * this.captchaLength;
        this.$refs.refCaptchaContainer.setAttribute("style", "max-width: " + wi + "px; min-width: " + wi + "px; width: " + wi + "px; height: " + this.letterSize + "px;");
        /** @type {Node} */
        const obj = vm.$refs.refCaptchaContainer.cloneNode(true);
        // vm.setDeclarationClass(obj);
        vm.$refs.refDrawingPanel.$el.append(obj);
        vm.$refs.refDrawingPanel.$el.setAttribute("style", "width: " + wi + 10 + "px; height: " + this.letterSize + "px;");
        domtoimage
          .toPng(obj, {
            width: wi,
            height: this.letterSize,
          })
          .then(function (dataUrl) {
            vm.image = dataUrl;
            vm.$refs.refDrawingPanel.$el.removeChild(obj);
            vm.modalDrawing = false;
            vm.$nextTick(() => {
              try {
                vm.$refs.refClientInput.$refs.input.focus();
              } catch {
                /** ignored */
              }
              vm.isLoading = false;
            });
          })
          .catch((error) => {
            vm.isLoading = false;
            vm.dialogLoader.showError(error.message);
          });
      });
    },
    changeInput() {
      if (this.clientInput.length > this.captchaLength) {
        this.$nextTick(() => {
          this.clientInput = this.clientInput.substring(0, this.captchaLength);
        });
      }
    },
    setDeclarationClass(node) {
      if (node.nodeType == 1) {
        node.setAttribute("class", "declaration " + node.getAttribute("class"));
        node.setAttribute("style", "color: black;" + node.getAttribute("style"));
      }
      if (node.hasChildNodes()) {
        node.childNodes.forEach((n) => {
          if (n.nodeType == 1) {
            this.setDeclarationClass(n);
          }
        });
      }
    },
  },
  created() {
    this.captcha = "";
    this.retries = 1;
    this.data = this.dialog.data;
    this.text = this.dialog.options.text;
    if (this.dialog.options.captchaLength) this.captchaLength = this.dialog.options.captchaLength;
    if (this.dialog.options.buttonOKText) this.buttonOKText = this.dialog.options.buttonOKText;
    if (this.dialog.options.buttonCancelText) this.buttonCancelText = this.dialog.options.buttonCancelText;
    this.generateCaptcha();
  },
  mounted() {
    // this.generateCaptcha();
  },
};
</script>

<style>
.myStyle0 {
  background-color: #ff7f9f;
  -moz-transform: rotate(20deg);
  -webkit-transform: rotate(20deg);
  transform: rotate(20deg);
}
.myStyle1 {
  background-color: #9595ee;
  -moz-transform: skewY(-24deg) skewX(-20deg);
  -webkit-transform: skewY(-24deg) skewX(-20deg);
  transform: skewY(-24deg) skewX(20deg);
}
.myStyle2 {
  background-color: #6ac0fa;
  -moz-transform: skewX(12deg);
  -webkit-transform: skewX(12deg);
  transform: skewX(12deg);
}
.myStyle3 {
  background-color: #0ac06a;
  -moz-transform: skewY(-14deg) skewX(5deg);
  -webkit-transform: skewY(-14deg) skewX(5deg);
  transform: skewY(-14deg) skewX(5deg);
}
.myStyle4 {
  background-color: #4f80fa;
  perspective: 3.5em;
  -moz-transform: skewY(-14deg) rotateZ(15deg);
  -webkit-transform: skewY(-14deg) rotateZ(15deg);
  transform: skewY(-14deg) rotateZ(15deg);
}
.myStyle5 {
  background-color: #cccc44;
  perspective: 13em;
  -moz-transform: skewY(10deg) rotateX(15deg);
  -webkit-transform: skewY(10deg) rotateX(15deg);
  transform: skewY(10deg) rotateX(15deg);
}
</style>
<style scoped>
.centered-input >>> input {
  letter-spacing: 10px;
}

#dpi {
  height: 1cm;
  left: -100%;
  position: absolute;
  top: -100%;
  width: 1cm;
}

.a4border {
  padding: 0cm;
}

.declaration,
.declaration >>> v-input__slot {
  border-color: gray;
  color: black;
  background-color: white;
}
</style>